import * as d3 from 'd3'
import BarChart from './BarChart' 

const YoutubeBarChart = ({ data, selectedTopic, setSelectedTopic }) => {
    var margin = {top:20, left:80, bottom:70, right:20};
    var width = 500 - margin.left - margin.right;
    var height = 500 - margin.top - margin.bottom;

    var aggregated = Array.from(
            d3.rollup(
                data,
                (v)=>d3.sum(v,(d)=>d.video_count),
                (d)=>d.topic,
            ),
            ([topic,video_count])=>({topic, video_count}),
        ); 

        const xscale = d3
            .scaleBand()
            .domain(aggregated.map((d) => d.topic))
            .range([0, width])
            .padding(0.2);

        const yscale = d3
            .scaleLinear()
            .domain([0, d3.max(aggregated, (d) => d.video_count)])
            .range([height, 0]);

        const colorscale = d3
            .scaleOrdinal()
            .domain(data.map((d) => d.topic))
            .range(["#C0392B","#1F3A5F", "#16A085"]);

    return (
        <div>
            <h4 className="youtube-heading">YouTube Video Count by Topic</h4>
            <BarChart aggregated={aggregated} width={width} height={height} margin={margin} xscale={xscale} yscale={yscale} colorscale={colorscale} selectedTopic={selectedTopic} setSelectedTopic={setSelectedTopic}/>
        </div>
    );
}
export default YoutubeBarChart; 